<script setup lang="ts">
import { defineProps, ref, withDefaults } from "vue";

import AuthSection from "@/components/common/AuthSection.vue";
import Footer from "@/components/common/Footer.vue";
import Header from "@/components/common/Header.vue";
import WhatsAppBtn from "@/components/common/WhatsAppBtn.vue";

interface Props {
  showFooter?: boolean;
  showPromo?: boolean;
}

withDefaults(defineProps<Props>(), {
  showFooter: true,
});

const isVisible = ref(false);
</script>

<template>
  <div id="site" :class="{ 'blurred-content': isVisible }">
    <div
      id="blurred-content"
      :class="{ 'active-blur-overlay': isVisible }"
      @click="isVisible = false"
    />
    <Header @open-sidebar="isVisible = true" />
    <main class="content">
      <slot />
      <WhatsAppBtn />
    </main>
    <Footer v-if="showFooter" />
  </div>
  <AuthSection :visible="isVisible" @close-sidebar="isVisible = false" />
</template>

<style scoped lang="scss">
#site {
  transition: filter 0.4s ease-in-out;
}

.blurred-content {
  filter: blur(5px);
  transition: filter 0.4s ease-in-out;
}

.active-blur-overlay {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 9999;
}

.content {
  padding: 0;
  margin: 0;
  height: inherit;
}
</style>
